import React from 'react'
import { Col } from 'react-bootstrap'

const ReusableTrendingRoducts = ({ img }) => {
  return (
    <>
      <Col lg={4} xs={6}>
        <div className="trending_roducts_main">
          <div className="trending_roducts_img">
            <img src={img} className="w-100" alt="" />
            <div className="trending_roducts_overlaay">
              <div className="icon"><i className="fa-regular fa-heart"></i></div>
              <div className="icon"><i className="fa-solid fa-bag-shopping"></i></div>
              <div className="icon"><i className="fa-regular fa-eye"></i></div>
            </div>
          </div>
          <div className="trending_roducts_text">
            <h4>Organic Fresh Vegetables</h4>
            <ul className="icson">
              <li><i className="fa-solid fa-star"></i></li>
              <li><i className="fa-solid fa-star"></i></li>
              <li><i className="fa-solid fa-star"></i></li>
              <li><i className="fa-solid fa-star"></i></li>
              <li><i className="fa-solid fa-star"></i></li>
            </ul>
            <p>$8.00-9.00</p>
          </div>
        </div>
      </Col>
    </>
  )
}

export default ReusableTrendingRoducts
